import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const StrollerIcon = createIcon({
  displayName: 'StrollerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M13.513 10.408v-7.646l-5.66706e-08 5.85563e-10c4.22254-.0436305 7.68096 3.34405 7.72459 7.56659 .0436305 4.22254-3.34405 7.68096-7.56659 7.72459 -4.22254.0436305-7.68096-3.34405-7.72459-7.56659 -.000270681-.0261964-.000406724-.052394-.000408122-.0785919v-3.027 0c0-.791424-.641576-1.433-1.433-1.433 0 0-2.77645e-12 0-2.77645e-12 0v0l-4.19772e-08-2.92921e-11c-.791424-.000552262-1.43345.640576-1.434 1.432 -2.32684e-07.00033345-3.4898e-07.000666899-3.48889e-07.00100035v.478"></path>
        <line x1="6.74" x2="21.08" y1="10.41" y2="10.41"></line>
        <path d="M18.051 20.576l6.48078e-09-5.18483e-11c-.138067.00110457-.249097.113925-.247992.251992 .00110457.138067.113925.249097.251992.247992 .137283-.0010983.247996-.112696.248-.249984l9.25832e-09 2.3312e-06c-.000549893-.138622-.113371-.250552-.251994-.250002 -1.32801e-06 5.26801e-09-2.65602e-06 1.05465e-08-3.98403e-06 1.58356e-08"></path>
        <path d="M8.972 20.578l4.6214e-09-1.84848e-11c-.13807.000552282-.24955.112928-.248998.250998 .000552282.13807.112928.24955.250998.248998 .137679-.000550718.248999-.112316.249-.249996l7.20102e-09-1.7803e-06c.000555747-.137518-.110474-.249448-.247992-.250004 -.00100337-4.05487e-06-.00200675-2.04494e-06-.00301009 6.02968e-06"></path>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const Stroller: FC<IconProps> = (props) => {
  return <CustomIcon as={StrollerIcon} {...props} />
}

export default memo(Stroller)
